/* Goons Up Rewards - behaviour layer for the gu-rw-* sections.
   Self-guarded: the snippet renders once per section, so this file can be
   requested by several script tags on one page and must only boot once.

     1. staggered scroll reveal for headings, plates and hero CTAs
     2. count-up on the big figures
     3. a floating section nav with a single-active scroll spy
     4. a light parallax on the hero photo
*/
(function () {
  if (window.__guRwInit) return;
  window.__guRwInit = true;

  var REVEAL = '.gu-rw__h2,.gu-rw__sub,.gu-rw__fine,.gu-rw__plate,.gu-rw-hero__cta';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function arr(n) { return Array.prototype.slice.call(n); }

  var io = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (typeof e.target.__rwCount === 'function') e.target.__rwCount();
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }) : null;

  /* ---- 1. reveal ---- */
  function reveal(root) {
    arr(root.querySelectorAll(REVEAL)).forEach(function (el, i) {
      if (el.__rwSeen) return;
      el.__rwSeen = 1;
      el.style.setProperty('--rw-delay', Math.min(i * 80, 480) + 'ms');
      if (io && !reduce) io.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---- 2. count-up ---- */
  function counters(root) {
    arr(root.querySelectorAll('.gu-rw-tag__stat b,.gu-rw-val__v,[data-rw-count]')).forEach(function (el) {
      if (el.__rwCount) return;
      var m = el.textContent.trim().match(/^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
      if (!m) return;
      var target = parseFloat(m[2].replace(/,/g, ''));
      if (!isFinite(target) || target < 50) return; // 1x / 3x / 5x read better static
      var pre = m[1], suf = m[3], grouped = m[2].indexOf(',') > -1;
      el.__rwCount = function () {
        if (reduce) return;
        var t0 = null, dur = 900;
        function step(t) {
          if (t0 === null) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          var v = Math.round(target * (1 - Math.pow(1 - p, 3)));
          el.textContent = pre + (grouped ? v.toLocaleString('en-US') : String(v)) + suf;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      };
      if (io && !reduce) io.observe(el);
    });
  }

  /* ---- 3. floating section nav ----
     The spy is position-based rather than an IntersectionObserver per section.
     With observers, a tall section and a short one can both satisfy the same
     rootMargin band and two pills light up at once. Picking the last section
     whose top has crossed the 42% line guarantees exactly one active item. */
  var nav, items = [], active = -1;

  function buildNav() {
    if (document.querySelector('.gu-rw-nav')) return;
    var roots = arr(document.querySelectorAll('.gu-rw'));
    if (roots.length < 3) return;

    items = [];
    roots.forEach(function (r, i) {
      var host = (r.closest && r.closest('.shopify-section')) || r;
      if (!host.id) host.id = 'gu-rw-s' + i;
      var h = r.querySelector('.gu-rw__h2') || r.querySelector('.gu-rw-hero__plate h1') || r.querySelector('h1,h2');
      var label = h ? h.textContent.trim() : '';
      if (!label) return;
      if (label.length > 18) label = label.slice(0, 17).trim() + '\u2026';
      items.push({ id: host.id, label: label, el: host, a: null });
    });
    if (items.length < 3) return;

    nav = document.createElement('nav');
    nav.className = 'gu-rw-nav';
    nav.setAttribute('aria-label', 'Rewards sections');

    items.forEach(function (it) {
      var a = document.createElement('a');
      a.href = '#' + it.id;
      a.className = 'gu-rw-nav__a';
      a.textContent = it.label;
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        it.el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + it.id);
      });
      it.a = a;
      nav.appendChild(a);
    });
    document.body.appendChild(nav);

    var accent = getComputedStyle(roots[0]).getPropertyValue('--rw-accent');
    if (accent && accent.trim()) nav.style.setProperty('--rw-accent', accent.trim());

    spy();
  }

  function spy() {
    if (!nav || !items.length) return;
    var line = (window.innerHeight || 0) * 0.42;
    var found = 0;
    for (var i = 0; i < items.length; i++) {
      if (items[i].el.getBoundingClientRect().top <= line) found = i;
    }
    if (found !== active) {
      if (active > -1 && items[active].a) items[active].a.classList.remove('is-on');
      if (items[found].a) items[found].a.classList.add('is-on');
      active = found;
    }
    // show the bar only once the first section is behind us
    var first = items[0].el.getBoundingClientRect();
    nav.classList.toggle('is-up', first.bottom < (window.innerHeight || 0) * 0.5);
  }

  /* ---- 4. hero parallax ---- */
  var heroImgs = [];
  function parallax() {
    if (reduce) return;
    heroImgs = arr(document.querySelectorAll('.gu-rw-hero__img img'));
  }
  function moveHero() {
    var vh = window.innerHeight || 1;
    heroImgs.forEach(function (img) {
      var wrap = img.closest && img.closest('.gu-rw-hero__wrap');
      if (!wrap) return;
      var r = wrap.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.setProperty('--rw-par', (p * -38).toFixed(1) + 'px');
    });
  }

  /* ---- one scroll listener for everything ---- */
  var queued = false;
  function onScroll() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      spy();
      if (!reduce) moveHero();
    });
  }

  function scan(scope) {
    arr(scope.querySelectorAll('.gu-rw')).forEach(function (root) {
      reveal(root);
      counters(root);
    });
  }

  function boot() {
    scan(document);
    buildNav();
    parallax();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // theme editor: a re-rendered section needs its reveals wired up again
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
    parallax();
    onScroll();
  });
})();
